import { Api } from "../config/request";

export default {
  getSettlementProcesses(queryParams) {
    return Api.get(`/driver-accounting/settlement-processes${queryParams}`);
  },
  triggerNextEvent(id) {
    return Api.post(
      `/driver-accounting/settlement-processes/${id}/trigger-next-event`
    );
  },
  createSettlementProcess(data) {
    return Api.post("/driver-accounting/settlement-processes", data);
  },
};
